enum StrataTypeEnum {
    None = 'NONE',
    Strata = 'STRATA',
}

export default StrataTypeEnum;
